export default "/images/destination-icon-last-1.svg?f9a390afbac47127a45cb7e06339e370";